import { BoxedSensorsIcon } from '@jouzen/ecom-components';

import type { WizardCarouselImageContent } from '@/app/[locale]/product/_steps/wizardData/types';

import { SlideshowItemIconData } from './_data/SlideshowItemIconData';

export interface SlideshowItemIconProps
  extends Pick<WizardCarouselImageContent, 'iconName'> {
  readonly className?: string;
}

const SlideshowItemIcon = ({ className, iconName }: SlideshowItemIconProps) => {
  const Icon = SlideshowItemIconData[iconName ?? 'default'] ?? BoxedSensorsIcon;

  return (
    <Icon
      className={className}
      data-cy={`slideshow-item-icon-${iconName}`}
      key={'iconName'}
    />
  );
};

export default SlideshowItemIcon;
